<template>
  <div class="validate-bank">
    <el-form :model="bindForm" ref="bindForm" :rules="bankRules">
      <el-form-item label="持卡人" prop="name">
        <el-input v-model="bindForm.name" placeholder="银行卡持有人"></el-input>
      </el-form-item>
      <el-form-item label="身份证号" prop="id_card">
        <el-input
          v-model="bindForm.id_card"
          placeholder="持卡人身份证号码"
        ></el-input>
      </el-form-item>
      <el-form-item label="银行卡号" prop="bank_card">
        <el-input
          v-model="bindForm.bank_card"
          placeholder="银行卡号"
          @blur="queryBankName"
        ></el-input>
      </el-form-item>
      <el-form-item label="所属银行" prop="bank_name">
        <el-input
          v-model="bindForm.bank_name"
          placeholder="所属银行"
        ></el-input>
      </el-form-item>

      <el-form-item label="预留手机号" prop="phone">
        <el-input
          v-model="bindForm.phone"
          placeholder="银行卡预留手机号"
        ></el-input>
      </el-form-item>
      <el-form-item label="验证码" prop="vercode">
        <el-input
          class="input-code"
          v-model="bindForm.vercode"
          placeholder="请输入验证码"
        ></el-input>
        <span
          class="btn-get-code btn"
          :class="{ 'btn-forbid': isDisabled }"
          @click="getCode"
          >{{ codeTxt }}</span
        >
      </el-form-item>
    </el-form>
    <div class="btn-confirm btn" @click="submitForm('bindForm')">确认</div>
  </div>
</template>

<script>
import { getBankName, getBankVercode, bindBank } from '@/api/income';
import { mapState } from 'vuex';
export default {
  name: 'bindForm',
  data() {
    let checkoutIDCode = (rule, value, callback) => {
      let reg =
        /^(^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$)|(^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])((\d{4})|\d{3}[Xx])$)$/;
      if (!value) {
        return callback(new Error('身份证号码不能为空'));
      } else if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的身份证号码'));
      }
    };
    let checkoutBankCard = (rule, value, callback) => {
      let reg = /^([1-9]{1})(\d{7,25}$)/;
      if (!value) {
        return callback(new Error('银行卡号不能为空'));
      } else if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的银行卡号'));
      }
    };
    let checkoutPhone = (rule, value, callback) => {
      let reg =
        /^(13[0-9]|14[01456879]|15[0-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;
      if (!value) {
        return callback(new Error('手机号不能为空'));
      } else if (reg.test(value)) {
        callback();
      } else {
        return callback(new Error('请输入正确的手机号'));
      }
    };
    return {
      bindForm: {
        name: '',
        id_card: '',
        bank_card: '',
        bank_name: '',
        phone: '',
        vercode: '',
      },
      bankRules: {
        name: [
          { required: true, message: '请输入银行卡持有人', trigger: 'blur' },
        ],
        id_card: [{ validator: checkoutIDCode, trigger: 'blur' }],
        bank_card: [{ validator: checkoutBankCard, trigger: 'blur' }],
        bank_name: [
          { required: true, message: '请输入所属银行', trigger: 'blur' },
        ],
        phone: [{ validator: checkoutPhone, trigger: 'blur' }],
        vercode: [
          { required: true, message: '验证码不能为空', trigger: 'blur' },
        ],
      },
      isDisabled: false,
      codeTxt: '获取验证码',
    };
  },

  computed: {
    ...mapState(['bankInfo']),
  },
  methods: {
    // 获取银行名接口
    async fetchGetBankname() {
      try {
        const res = await getBankName({
          bank_card: this.bindForm.bank_card,
        });
        this.bindForm.bank_name = res.data.bank_name;
      } catch (error) {
        console.log(error);
      }
    },
    // 获取银行卡验证码
    async fetchBankVercode() {
      let data = {
        name: this.bindForm.name,
        id_card: this.bindForm.id_card,
        bank_card: this.bindForm.bank_card,
        bank_name: this.bindForm.bank_name,
        phone: this.bindForm.phone,
      };
      try {
        await getBankVercode(data);
        this.$message.success('发送成功');
        this.countDown();
      } catch (error) {
        console.log(error);
      }
    },
    // 绑定银行卡接口
    async fetchBindBank() {
      let data = {
        name: this.bindForm.name,
        id_card: this.bindForm.id_card,
        bank_card: this.bindForm.bank_card,
        bank_name: this.bindForm.bank_name,
        phone: this.bindForm.phone,
        vercode: this.bindForm.vercode,
      };
      try {
        await bindBank(data);
        this.$message.success('操作成功');
        this.$router.push({ name: 'bindInfo', params: { update: 1 } });
      } catch (error) {
        console.log(error);
      }
    },
    // 验证输入获取验证码
    getCode() {
      let validateList = [];
      this.$refs.bindForm.validateField(
        ['name', 'id_card', 'bank_card', 'bank_name', 'phone'],
        errMsg => {
          validateList.push(errMsg);
        },
      );

      if (validateList.every(item => item === '')) {
        this.fetchBankVercode();
      }
    },
    // 验证银行卡号查询银行卡名
    queryBankName() {
      this.$refs.bindForm.validateField('bank_card', errMsg => {
        if (!errMsg) {
          this.fetchGetBankname();
        }
      });
    },
    // 倒计时
    countDown() {
      let time = 59;
      const interId = setInterval(() => {
        time--;
        if (time > 0) {
          this.codeTxt = `重新发送${time}S`;
          this.isDisabled = true;
        } else {
          clearInterval(interId);
          this.isDisabled = false;
          this.codeTxt = '获取验证码';
        }
      }, 1000);
    },
    // 提交绑定
    submitForm(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.fetchBindBank();
        } else {
          return false;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$--color-primary: #fd9b21;
.el-form-item {
  display: flex;
  margin-bottom: 38px;
  .el-input {
    width: 360px;
    height: 40px;
  }
  ::v-deep .el-form-item__label {
    padding-right: 40px;
    font-size: 16px;
    width: 120px;
  }
}
.validate-bank {
  margin: 0 auto;
  .input-code {
    width: 220px;
    margin-right: 20px;
  }

  .btn-get-code {
    display: inline-block;
    width: 120px;
    height: 32px;
    background: $--color-primary;
    border-radius: 8px;
    color: #ffffff;
    line-height: 32px;
    text-align: center;
  }
  .btn-confirm {
    width: 200px;
    height: 50px;
    color: #ffffff;
    font-size: 20px;
    border-radius: 8px;
    background: $--color-primary;
    margin: 0 auto;
    line-height: 50px;
    text-align: center;
    margin-top: 73px;
  }
}
.btn {
  cursor: pointer;
  &:hover {
    filter: brightness(105%);
  }
}
.btn-forbid {
  cursor: not-allowed;
  background: #d9d9d9 !important;
  &:hover {
    filter: brightness(100%);
  }
}
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  .el-form-item__label-wrap
  > .el-form-item__label:before,
::v-deep
  .el-form-item.is-required:not(.is-no-asterisk)
  > .el-form-item__label:before {
  content: '';
}
</style>
